import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-CollectionList',
	loading: 'c-CollectionList--loading',
};

export const Style = {
	[CSS.container]: {
		padding: DefaultTheme.space(1),
	},
	[CSS.loading]: {
		display: 'flex',
		'justify-content': 'center',
	},
};
